import i18n from '@/i18n/i18n';

/*
 * A sum with its currency sign («20,353.00 ₪»), formatted like the Amount cells. Druk (16.9.2026):
 * the sign, not the word, and it must never land on a line of its own - so the space between the
 * figure and the sign is a non-breaking one, and the bidi marks the formatter adds are dropped.
 */
export const formatMoney = (value: number, currency: string | undefined): string =>
  value
    .toLocaleString(i18n.language, { style: 'currency', currency: currency || 'ILS', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .replace(/[‎‏؜]/g, '')
    .replace(/\s/g, ' ');
